module.exports = __webpack_public_path__ + "static/media/graduation-cap.1409ec1c.svg";